import React, { Component } from 'react';

import './PhoneInput.scss';
import Input from '../Input';

export default class PhoneInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      placeholderDisplayed: true,
      formattedNumber: '',
    };

    this.handleFocus = this.handleFocus.bind(this);
  }

  componentDidMount() {
    const { inputValue } = this.props;

    if (inputValue) {
      let formattedNumber = inputValue;
      //take out +1 from input value
      if (inputValue[0] == '+' && inputValue[1] == '1') {
        formattedNumber = inputValue.substring(2);
      }
      this.handlePhoneChange(formattedNumber, true);
    }
  }

  componentDidUpdate() {
    const { inputValue } = this.props;
    //for clearing the input value
    if (inputValue != this.state.formattedNumber && inputValue == '') {
      this.setState({ formattedNumber: inputValue });
    }
  }

  handleFormatPhone(phone){
    if (phone) {
      return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }
  }

  handleCountPhone(phone) {
    if (phone) {
      return phone.replace(/[^0-9]/g, '');
    }
  }

  handlePhoneChange(phoneNumber, fromMount=false) {
    const numbersOnly = this.handleCountPhone(phoneNumber); 
    if (!numbersOnly) {
      this.setState({ formattedNumber: '' });
      if (!fromMount) this.props.handlePhoneChange('');
    }
    if (numbersOnly && numbersOnly.length <= 10) {
      const formattedNumber = this.handleFormatPhone(numbersOnly);
      if (!fromMount) this.props.handlePhoneChange(formattedNumber);
      this.setState({ formattedNumber });
    }
  }

  handleFocus(e) {
    const { handleFocus } = this.props;
    if (handleFocus) {
      this.inputToFocus.focus();
    }
  }

  render() {
    const { 
      classNameInput, 
      handleKeyDown, 
      inputStyle, 
      idInput, 
    } = this.props;

    const style = inputStyle ? inputStyle : {};

    let parentClassname = 'PhoneInput' + (classNameInput ? (' ' + classNameInput) : '');

    return (
      <div className={parentClassname} style={style} id={idInput ? idInput : ''}>
        <div className='country-code'>+1</div>
        <Input 
          ref={el => this.inputToFocus = el}
          value={this.state.formattedNumber} 
          placeholder={ this.props.inputPlaceholder} 
          onChange={(e) => this.handlePhoneChange(e.target.value)}
          onKeyDown={handleKeyDown ? handleKeyDown : () => {}}
          onClick={this.handleFocus}
        />
      </div>
    ); 
  }
}



// WEBPACK FOOTER //
// ./src/components/PhoneInput/index.js